/* ═══════════════════════════════════════════════════
   Atlantic Naturals — Cart Drawer Enhancements
   - Free shipping progress bar
   - Upsell "Add" button handler
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  /* ─── FREE SHIPPING BAR ───
     Shipping is free on all U.S. orders, so the cart shows a static badge
     (see snippets/cart-drawer.liquid). No threshold/progress logic needed. */

  /* ─── REMOVE ITEM WHEN QUANTITY REACHES ZERO ─── */
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input.matches || !input.matches('.cart-drawer quantity-input input')) return;
    var val = parseInt(input.value, 10);
    if (val === 0) {
      var cartItems = input.closest('cart-drawer-items');
      if (cartItems && typeof cartItems.updateQuantity === 'function') {
        e.stopImmediatePropagation();
        cartItems.updateQuantity(input.dataset.index, 0, e, input.getAttribute('name'), input.dataset.quantityVariantId);
      }
    }
  }, true);

  /* ─── UPSELL "ADD" BUTTON ─── */
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.an-cart-upsell__card-btn');
    if (!btn) return;

    const variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch(window.Shopify && window.Shopify.routes
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: 1 }] }),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Add to cart failed');
        return response.json();
      })
      .then(function () {
        // Fetch updated cart sections to re-render the drawer
        return fetch(
          (window.Shopify && window.Shopify.routes
            ? window.Shopify.routes.root
            : '/') + 'cart.js'
        );
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cartData) {
        // Publish cart update so the drawer re-renders via CartDrawerItems
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-upsell',
            cartData: cartData,
          });
        }

        // Also trigger a section re-render the same way product-form does
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          fetch(
            (window.Shopify && window.Shopify.routes
              ? window.Shopify.routes.root
              : '/') +
              '?sections=cart-drawer,cart-icon-bubble'
          )
            .then(function (r) {
              return r.json();
            })
            .then(function (sections) {
              if (sections['cart-drawer']) {
                var parser = new DOMParser();
                var doc = parser.parseFromString(sections['cart-drawer'], 'text/html');

                // Update cart drawer inner
                var newInner = doc.querySelector('.drawer__inner');
                var currentInner = document.querySelector('.drawer__inner');
                if (newInner && currentInner) {
                  currentInner.innerHTML = newInner.innerHTML;
                }

                // Update cart-drawer is-empty class
                var newCartDrawer = doc.querySelector('cart-drawer');
                if (newCartDrawer && cartDrawer) {
                  if (newCartDrawer.classList.contains('is-empty')) {
                    cartDrawer.classList.add('is-empty');
                  } else {
                    cartDrawer.classList.remove('is-empty');
                  }
                }

                // Update cart-drawer-items is-empty class
                var newItems = doc.querySelector('cart-drawer-items');
                var currentItems = document.querySelector('cart-drawer-items');
                if (newItems && currentItems) {
                  if (newItems.classList.contains('is-empty')) {
                    currentItems.classList.add('is-empty');
                  } else {
                    currentItems.classList.remove('is-empty');
                  }
                }

                // (shipping badge is static — nothing to re-init)
              }

              // Update cart icon bubble (replace full contents so the count
              // bubble appears even when the cart started empty)
              if (sections['cart-icon-bubble']) {
                var iconBubble = document.getElementById('cart-icon-bubble');
                if (iconBubble) {
                  var parser2 = new DOMParser();
                  var bubbleDoc = parser2.parseFromString(sections['cart-icon-bubble'], 'text/html');
                  var newSection = bubbleDoc.querySelector('.shopify-section');
                  if (newSection) {
                    iconBubble.innerHTML = newSection.innerHTML;
                  }
                }
              }
            })
            .catch(function () {
              // Fallback: reload page
              window.location.reload();
            });
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = '+ Add';
        alert('Could not add item to cart. Please try again.');
      });
  });
})();
